/**
 * @description 自定义事件，自定义代码
 * @author wangfupeng
 */

export default function (eventData = {}) {
    // 自定义事件的代码
    const code = eventData.code || ''

    // 构建函数
    const fnBody = `try {
        ${code}
    } catch (ex) {
        console.error('customeEvent code error', ex)
    }`
    const fn = new Function(fnBody)

    // 执行
    fn.call(window)
}
